<template>
<span class="wrapper" :class="{'flex-end':$store.state.session.user.UserID === message.From}">
  <div class="" :class="{'messageBalloonMainReverse':$store.state.session.user.UserID === message.From,'messageBalloonMain':$store.state.session.user.UserID !== message.From}">
    <!-- <div class="spacer" v-if="$store.state.session.user.UserID === message.From" /> -->
    <div :class="{
      speechBubbleTailedLeft:
        $store.state.session.user.UserID !== message.From &&
        !message.continueFromSameBuddy,
      speechBubbleNonTailedLeft:
        $store.state.session.user.UserID !== message.From &&
        message.continueFromSameBuddy,
      speechBubbleTailedRight:
        $store.state.session.user.UserID === message.From &&
        !message.continueFromSameBuddy,
      speechBubbleNonTailedRight:
        $store.state.session.user.UserID === message.From &&
        message.continueFromSameBuddy
    }"
    >
      <ForwardedMessageRow v-if="message.isForwarded" />
      <RepliedMessageRow v-if="message.ReplyMessage" :message="message.ReplyMessage" />

      <div class="senderName" :style="{ color: userColor(message.From) }" v-if="
        message.isGroup === true &&
          $store.state.session.user.UserID !== message.From &&
          !message.continueFromSameBuddy
      "
      >
        {{ getUserNameDisplay(message.From) }}
      </div>

      <ReactionPicker :visible="showReactionPicker" @select="onToggleReaction" @close="closeReactionPicker" />
      <MessageMenuDropDown :message="message" @open-reactions="openReactionPicker" />

      <ImageMessageBalloonMultiImages v-if="message.MediaURLs.length > 1" :images="message.MediaURLs" :message="message" />
      <img :src="aaa" @click="openGalleryView" class="imageMessage" v-else>
      <div class="messageTextContainer">
        {{ message.Body }}
      </div>

      <MessageBalloonInfoRow :message="message" />
    </div>
    <MessageReactions :reactions="message.Reactions" :message="message" @toggle-reaction="onToggleReaction" @open-picker="openReactionPicker" />

    <img class="forwardButton" src="/images/forward.png" v-if="$store.state.session.user.UserID !== message.From && message.MessageType !== 0" @click="forwardMsg">

    <div class="spacer" v-if="$store.state.session.user.UserID !== message.From" />
  </div>
</span>
</template>

<script>
import ForwardedMessageRow from './common/ForwardedMessageRow.vue'
import RepliedMessageRow from './common/RepliedMessageRow.vue'
import MessageBalloonInfoRow from './common/MessageBalloonInfoRow.vue'
import MessageMenuDropDown from './common/MessageMenuDropDown.vue'
import MessageReactions from './common/MessageReactions.vue'
import ReactionPicker from './common/ReactionPicker.vue'
import ImageMessageBalloonMultiImages from './ImageMessageBalloonMultiImages.vue'
import EventBus from '@/eventbus.js'
import {
  messageMixin
} from '@/mixins/messageMixin.js'
require('@/security.js')
var vm
export default {
  components: {
    ForwardedMessageRow,
    RepliedMessageRow,
    ImageMessageBalloonMultiImages,
    MessageBalloonInfoRow,
    MessageMenuDropDown,
    MessageReactions,
    ReactionPicker
  },
  data () {
    return {
      imageData: '',
      rnd: 0,
      showReactionPicker: false
    }
  },
  mixins: [messageMixin],

  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  asyncComputed: {
    async aaa () {
      var vm = this
      if (this !== undefined && vm !== undefined) {
        var str = await this.image(vm.message.MediaURLs[0])
        return str
      } else {
        return ''
      }
    }
  },
  mounted () {
    vm = this
  },
  methods: {
    onToggleReaction (emoji) {
      this.toggleReaction(this.message, emoji)
      this.showReactionPicker = false
    },
    openReactionPicker () {
      this.showReactionPicker = true
    },
    closeReactionPicker () {
      this.showReactionPicker = false
    },
    image (url) {
      vm = this
      return new Promise(function (resolve, reject) {
        if (vm.message.mv <= 1) {
          resolve(vm.makeBlob(url, url))
        } else {
          let key = '6a61e395-b49a-4468-bee0-27644e95308f'
          var iv = key.split('').reverse().join('')
          let encryptedBody = vm.ewk(url, key, iv)
          resolve(vm.makeBlob(process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + url + '&s=' + encodeURIComponent(encryptedBody), url))
        }
      })
    },
    async image2 (url) {
      if (vm.message.mv <= 1) {
        await vm.makeBlob(url, url)
      } else {
        let key = '6a61e395-b49a-4468-bee0-27644e95308f'
        var iv = key.split('').reverse().join('')
        let encryptedBody = vm.ewk(url, key, iv)
        await vm.makeBlob(process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + url + '&s=' + encodeURIComponent(encryptedBody), url)
      }
    },
    openGalleryView () {
      var vm = this
      this.$store.state.conversation.activeConversation.preview.imageGalleryView.isVisible = true
      setTimeout(function () {
        EventBus.$emit('imageGalleryViewOpenedWithMessage', vm.message)
      }, 50)
    },

    forwardMsg () {
      let messageToForward = this.message
      this.$store.commit('setMessageToForward', messageToForward)

      this.$store.state.display.modal.viewState = 'forwardMessage'
      this.$modal.show('homepage')
    }
  }
}

</script>

<style lang="less" scoped>
  @import "../../../../../style/messageBalloon";

  .imageMessage {
    width: 300px;
    cursor: pointer;
  }

</style>
